import { JSONSchema7 } from "json-schema";

export const SubscribeNewsletterMetadataSchema: JSONSchema7 = {
  description: "Recommends the user to subscribe to the newsletter.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
